import { React, useCallback, useState, useEffect } from 'react'
import useEmblaCarousel from 'embla-carousel-react'
import './ProductCarousel.css'
import { ShopifyCard } from './ProductVariantCards'
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs'

export const ProductCarousel = ({ items }) => {
    const [emblaRef, emblaApi] = useEmblaCarousel();
    const [canScrollPrev, setCanScrollPrev] = useState(false);
    const [canScrollNext, setCanScrollNext] = useState(false);

    const scrollPrev = useCallback(() => {
        if (emblaApi) emblaApi.scrollPrev();
    }, [emblaApi])

    const scrollNext = useCallback(() => {
        if (emblaApi) emblaApi.scrollNext();
    }, [emblaApi])

    useEffect(() => {
        if (!emblaApi) return;

        const updateScrollButtons = () => {
            setCanScrollPrev(emblaApi.canScrollPrev());
            setCanScrollNext(emblaApi.canScrollNext());
        };

        updateScrollButtons();
        emblaApi.on('select', updateScrollButtons);
        emblaApi.on('reInit', updateScrollButtons);
    }, [emblaApi]);

    return (
        <div className='carousel-wrapper'>
            {canScrollPrev && (
                <button className="arrow left" onClick={scrollPrev}><BsChevronLeft size={30} /></button>
            )}
            <div className="embla" ref={emblaRef}>
                <div className="embla__container">
                    {items}
                </div>
            </div>
            {canScrollNext && (
                <button className="arrow right" onClick={scrollNext}><BsChevronRight size={30} /></button>
            )}
        </div>
    )
}
